module.exports = __webpack_public_path__ + "static/media/OS_careers.d67c93ac.jpg";